



































































































import { Component, Vue, Prop } from "../../../shared/vuepack";
import {
  ResourceFormDocumentBase, ResourceFormPlanType, ResourceFormDocument,
  resourceFormPlanTypeMap,
  FormDocumentType
} from "@/shared/types";
import moment from "moment";
import CommunicationEmployerGroups from "../communications/CommunicationEmployerGroups.vue";
import { useUserStore } from "@/shared/store/user";
import { useResourceFormStore } from "@/employer/store/ResourceForm";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    CommunicationEmployerGroups
  }
})
export default class ResourceFormCreate extends Vue {
  userStore = useUserStore();
  resourceFormStore = useResourceFormStore();
  notifierStore = useNotifierStore();
  featureFlagStore = useFeatureFlagStore();

  isSubmitting = false;
  showEmployerSelection = false;
  partnerOptions = [];

  @Prop()
  model: ResourceFormDocument;

  @Prop()
  onSave: (ResourceForm: ResourceFormDocumentBase) => void;

  @Prop()
  onCancel: () => void;

  @Prop({ default: false })
  disableSave: boolean;

  @Prop({ default: "Create" })
  submitButtonText: string;

  get saveDisabled () {
    return this.disableSave || this.$validator.errors.any() || this.canOptOut;
  }

  get planTypesOptionsCurrentPartner () {
    return this.resourceFormStore.getPlanTypesByPartner(this.userStore.currentPartner.partnerId).map(x => {
      return { value: x, text: resourceFormPlanTypeMap[x] };
    });
  }

  get partnersServicedOptionsCurrentPartner () {
    return this.resourceFormStore.getPartnersServicedByPartner(this.userStore.currentPartner.partnerId).map(x => {
      return { value: x.partnerId, text: x.name };
    });
  }

  get hasServicedPartners () {
    return this.partnersServicedOptionsCurrentPartner.length > 0;
  }

  selectAllPartners () {
    this.model.sellingPartnerIds = this.resourceFormStore.getPartnersServicedByPartner(
        this.userStore.currentPartner.partnerId).map(x => x.partnerId);
  }

  get showSelectAllPartners () {
    return this.partnersServicedOptionsCurrentPartner.length !== this.model.sellingPartnerIds.length;
  }

  get canOptOut () {
    return this.model !== null && this.model.canOptOut;
  }

  get isOptedOut () {
    return this.model !== null && this.model.isOptedOut;
  }

  opt (isOptOut: boolean) {
    this.isSubmitting = true;
    this.resourceFormStore.optInOrOptOut({
          partnerId: this.userStore.currentPartner.partnerId,
          formDocumentId: this.model.formDocumentId,
          isOptOut
        })
        .then(() => {
          this.model.isOptedOut = isOptOut;
        })
        .catch(
            err => {
              this.notifierStore.setDanger("Failed to change opt-out state for this resource.");
            }
        ).finally(() => {
      this.isSubmitting = false;
    });
  }

  onOptOut () {
    if (this.model.canOptOut && !this.model.isOptedOut) {
      this.opt(true);
    }
  }

  onOptIn () {
    if (this.model.canOptOut && this.model.isOptedOut) {
      this.opt(false);
    }
  }

  get showEmployerCheckbox () {
    return this.model.employers.length > 0 || this.showEmployerSelection;
  }

  get employerCheckboxDisabled () {
    return this.model.employers.length > 0;
  }

  switchEmployerSelectionState (isChecked: boolean) {
    this.showEmployerSelection = isChecked;
    if (!isChecked) {
      this.model.isEmployerExclusionList = false;
    }
  }

  beforeMount () {
    this.$validator.extend("dateLess", {
      getMessage: _ => "Start date must occur before end date.",
      validate: _ => {
        if (!this.model.dateAvailableEnd) {
          return true;
        }
        const result = moment(this.model.dateAvailableStart) < moment(this.model.dateAvailableEnd);
        if (!result) {
          this.model.dateAvailableEnd = "";
        } else {
          this.$validator.reset();
        }

        return result;
      }
    });
    this.$validator.extend("dateMore", {
      getMessage: _ => "End date must occur after start date.",
      validate: _ => {
        const result = moment(this.model.dateAvailableStart) < moment(this.model.dateAvailableEnd);
        if (!result) {
          this.model.dateAvailableStart = "";
        } else {
          this.$validator.reset();
        }

        return result;
      }
    });
    this.showEmployerSelection = this.model.employers.length > 0;
  }

  mounted () {
    this.partnerOptions = this.userStore.partnersWithUserRoles.map((x: any) => {
      return { value: x.partnerId, text: x.companyName };
    });
  }

  validateAndSave () {
    this.$validator.validate().then(isValid => {
      if (isValid) {
        this.onSave(this.model);
      }
    });
  }

  get canShowTestLink () {
    return this.model.downloadUrl && !this.errors.has("Download Url");
  }

  get hasMoreThanOnePlanType () {
    return this.planTypesOptionsCurrentPartner.length > 1;
  }

  selectAllPlanTypes () {
    this.model.resourceFormPlanTypes = this.resourceFormStore.getPlanTypesByPartner(this.userStore.currentPartner.partnerId)
        .map(x => x);
  }

  get showSelectAllPlanTypes () {
    return !this.canOptOut && this.planTypesOptionsCurrentPartner.length !== this.model.resourceFormPlanTypes.length;
  }
  get formDocumentTypeOptions () {
    return Object.keys(FormDocumentType)
      .filter(k => FormDocumentType[k] !== FormDocumentType.None)
      .map(k => ({ value: FormDocumentType[k], text: k }));
  }
  get isLink (): boolean {
    return this.model && this.model.formDocumentType === FormDocumentType.Link;
  }
  get linkFeatureEnabled (): boolean {
    return this.featureFlagStore.featureFlagsAvailable
      && this.featureFlagStore.flags.bend19788FormDocumentLinksEnabled;
  }
}
